import { captureException } from '@g/utils/sentryInstall'

let presentingPromise

function escapeHtml (value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

function isImmediateUnauthorized (diagnostic) {
  return diagnostic && diagnostic.code === 'AUTH-05'
}

export function getAuthDiagnosticMessage (diagnostic) {
  const description = isImmediateUnauthorized(diagnostic)
    ? '登入資料已成功儲存，但伺服器隨即判定登入失效。'
    : '系統無法正確儲存登入資料，因此沒有完成登入。'

  return `${description}<br><br>錯誤代碼：<strong>${escapeHtml(diagnostic && diagnostic.code)}</strong><br>請回報客服協助確認。診斷資料不包含密碼、驗證碼或登入憑證。`
}

export function reportAuthDiagnostic (diagnostic) {
  if (!diagnostic) return
  captureException(new Error(`Auth diagnostic ${diagnostic.code}`), {
    tags: {
      auth_error_code: diagnostic.code,
      auth_reason: diagnostic.reason,
      auth_project: diagnostic.project,
      auth_source: diagnostic.source,
      auth_in_app: String(diagnostic.inApp || false),
      auth_is_android: String(Boolean(diagnostic.isAndroid)),
      auth_is_samsung: String(Boolean(diagnostic.isSamsung)),
      auth_token_length: String(diagnostic.tokenLength || 0),
      auth_stored_token_length: String(diagnostic.storedTokenLength || 0),
      auth_request_path: diagnostic.requestPath || '',
      auth_storage_error_name: diagnostic.storageErrorName || '',
    },
  })
}

function emitCustomerReport (vueApp, diagnostic) {
  if (!vueApp.$eventBus || !vueApp.$eventType || !vueApp.$eventType.ErrorReportScreenshots) return
  vueApp.$eventBus.$emit(vueApp.$eventType.ErrorReportScreenshots, {
    data: {
      name: diagnostic.code,
      message: '登入異常診斷',
      diagnostic,
    },
  })
}

export function presentAuthDiagnostic (diagnostic) {
  if (!diagnostic || presentingPromise) return presentingPromise || Promise.resolve(false)

  const vueApp = window.vueApp
  if (!vueApp || typeof vueApp.$confirm !== 'function') {
    console.error('登入異常診斷', diagnostic)
    return Promise.resolve(false)
  }

  const canReportInApp = Boolean(diagnostic.inApp && vueApp.$eventBus && vueApp.$eventType)
  presentingPromise = vueApp.$confirm(getAuthDiagnosticMessage(diagnostic), {
    title: isImmediateUnauthorized(diagnostic) ? '登入驗證失敗' : '登入資料儲存失敗',
    buttonTrueText: canReportInApp ? '回報客服' : '我知道了',
    buttonFalseText: canReportInApp ? '關閉' : false,
    width: 360,
  }).then((shouldReport) => {
    if (shouldReport && canReportInApp) {
      emitCustomerReport(vueApp, diagnostic)
    }
    return shouldReport
  }).finally(() => {
    presentingPromise = null
  })

  return presentingPromise
}
